import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=cc05b23c&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc05b23c')) {
      api.createRecord('cc05b23c', component.options)
    } else {
      api.reload('cc05b23c', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=cc05b23c&", function () {
      api.rerender('cc05b23c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lK1yRvwVK7PU/JS/pricehelp.vue"
export default component.exports